/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from './page-component-container.component';
import * as import3 from '../../../html-utils/css-var.directive';
import * as import4 from '../../responsive.directive';
import * as import5 from '../../responsive.service';
import * as import6 from '../../navigation.service';
import * as import7 from '../../../ui-elements/swipable.directive';
import * as import8 from '../../page';
const styles_PageComponentContainerComponent:any[] = ([] as any[]);
export const RenderType_PageComponentContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PageComponentContainerComponent,
  data: {}
}
);
export function View_PageComponentContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{viewContainerRef: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'component-container-shroud'
      ]
      ],[[
        2,
        'open',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['alignment-full']),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'component-container-wrapper'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]
      ,
      [
        'woa-swipable',
        ''
      ]

    ]
    ,(null as any),[
      [
        (null as any),
        'onSwipe'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.PageComponentContainerComponent = v.component;
      if (('onSwipe' === en)) {
        const pd_0:any = ((<any>co.dismissPage()) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.ignore($event)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'initialised',
      'alignment-top',
      'alignment-bottom',
      'alignment-left',
      'alignment-right',
      'alignment-full',
      'handle-enabled'
    ]
    ),
      import0.ɵdid(671744,(null as any),0,import3.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--specified-width',
      '--specified-height'
    ]
    ),
    import0.ɵdid(737280,(null as any),0,import4.ResponsiveDirective,[
      import0.ElementRef,
      import5.ResponsiveService,
      import6.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,{
      pillarboxedOnMobile: [
        0,
        'pillarboxedOnMobile'
      ]
      ,
      pillarboxedOnDesktop: [
        1,
        'pillarboxedOnDesktop'
      ]

    }
    ,(null as any)),
    import0.ɵdid(212992,(null as any),0,import7.SwipableDirective,[
      import0.ElementRef,
      import0.Renderer2
    ]
    ,{
      swipeDirection: [
        0,
        'swipeDirection'
      ]
      ,
      swipeRestoreDelay: [
        1,
        'swipeRestoreDelay'
      ]
      ,
      swipeScroller: [
        2,
        'swipeScroller'
      ]

    }
    ,{onSwipe: 'onSwipe'}),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'content',
        1
      ]

    ]
    ,(null as any),0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import2.PageComponentContainerComponent = v.component;
    const currVal_1:any = 'component-container-shroud';
    const currVal_2:any = ck(v,3,0,(co.geometry.alignment === co.PageAlignment.FULL));
    ck(v,2,0,currVal_1,currVal_2);
    const currVal_3:any = 'component-container-wrapper';
    const currVal_4:any = ck(v,8,0,co.initialised,(co.geometry.alignment === co.PageAlignment.TOP),(co.geometry.alignment === co.PageAlignment.BOTTOM),(co.geometry.alignment === co.PageAlignment.LEFT),(co.geometry.alignment === co.PageAlignment.RIGHT),(co.geometry.alignment === co.PageAlignment.FULL),(co.responsiveService.isTouchDevice && (co.swipeDirection !== co.Direction.NONE)));
    ck(v,7,0,currVal_3,currVal_4);
    const currVal_5:any = ck(v,10,0,co.geometry.width,co.geometry.height);
    ck(v,9,0,currVal_5);
    const currVal_6:any = co.geometry.pillarboxedOnMobile;
    const currVal_7:any = co.geometry.pillarboxedOnDesktop;
    ck(v,11,0,currVal_6,currVal_7);
    const currVal_8:any = co.swipeDirection;
    const currVal_9:any = 300;
    const currVal_10:any = ((co.pageSpec.componentRef.instance.pageLayout == null)? (null as any): co.pageSpec.componentRef.instance.pageLayout.scrollerElementRef);
    ck(v,12,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    var co:import2.PageComponentContainerComponent = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,4).transform(co.open$));
    ck(v,1,0,currVal_0);
  });
}
function View_PageComponentContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-page-component-container',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).dismissPage($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_PageComponentContainerComponent_0,RenderType_PageComponentContainerComponent)),
    import0.ɵdid(1294336,(null as any),0,import2.PageComponentContainerComponent,[
      import8.PageSpec,
      import5.ResponsiveService,
      import6.NavigationService,
      import0.Renderer2,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PageComponentContainerComponentNgFactory:import0.ComponentFactory<import2.PageComponentContainerComponent> = import0.ɵccf('woa-page-component-container',import2.PageComponentContainerComponent,View_PageComponentContainerComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/orchestration/page-container/page-component-container/page-component-container.component.ngfactory.ts